// `/relances/pending` — pending-relances queue route (Wave 5d Agent 5d.3,
// US-165 gap-design).

import { createRoute } from '@tanstack/react-router';

import { PendingQueuePage } from '@/features/relances/PendingQueuePage';

import { Route as RelancesLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => RelancesLayoutRoute,
  path: 'pending',
  component: PendingRoute,
});

function PendingRoute() {
  return <PendingQueuePage />;
}
